export default __webpack_public_path__ + "static/media/skadekostnadsreducering.fab2f276.jpg";